<script lang="ts" setup>
defineProps<{
  title?: string
  text?: string
}>()
</script>

<template>
  <v-expansion-panel :title="title" :text="text">
    <template v-if="$slots.title" #title>
      <slot name="title" />
    </template>
    <template v-if="$slots.text" #text>
      <slot name="text" />
    </template>
  </v-expansion-panel>
</template>

<style lang="scss" scoped>
.v-expansion-panel {
  background: $c-grey-light-4;
  border-radius: 4px !important;

  :deep(.v-expansion-panel-title) {
    font-weight: 800;
    padding-right: 5 * $bw;
    color: rgb(var(--v-theme-on-surface-high-xqes));
  }

  :deep(.v-expansion-panel-title__overlay) {
    background-color: $c-black;
  }

  :deep(.v-expansion-panel-title__icon) {
    color: rgb(var(--v-theme-brand-accent-xqes));
  }

  :deep(.v-expansion-panel-text) {
    border-top-color: transparent;
    padding-left: 2.5 * $bw;
    padding-right: 2.5 * $bw;
    color: rgb(var(--v-theme-on-surface-xqes));
  }
}
.v-expansion-panel--active {
  background: $c-grey-light-1;
}
</style>
